exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".jumbotron{background-size:cover;background-color:transparent;color:white;padding:0px}.headline h1{margin-top:40px !important;margin-bottom:40px;color:white;text-shadow:0px 0px 3px #333;font-size:48px;font-weight:700;line-height:52px}.headline h3{font-size:24px;line-height:28px !important;font-weight:300;margin-bottom:30px}@media screen and (max-width: 575px){.headline h1{font-weight:600;font-size:36px;line-height:42px}.headline h3{font-size:18px;line-height:22px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Component/Jumbotron.scss
// module id = 1085
// module chunks = 0